import { render, staticRenderFns } from "./SortList.vue?vue&type=template&id=110f46aa&scoped=true"
import script from "./SortList.vue?vue&type=script&lang=js"
export * from "./SortList.vue?vue&type=script&lang=js"
import style0 from "./SortList.vue?vue&type=style&index=0&id=110f46aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110f46aa",
  null
  
)

export default component.exports